import script from './basic-year-table.vue_vue_type_script_lang.mjs';
export { default } from './basic-year-table.vue_vue_type_script_lang.mjs';
import { render } from './basic-year-table.vue_vue_type_template_id_441df31d_lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/basic-year-table.vue";
//# sourceMappingURL=basic-year-table.mjs.map
